/* eslint-disable react/react-in-jsx-scope */
import classNames from 'classnames'
import { CorporateWithSeats } from 'entities-next/corporate'
import { useFormikContext } from 'formik'
import { NumberField, SwitchField, TextField } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { FormSection } from 'scenes/Dashboard/components-next/Sections'
import { CorporateFeaturesSelect } from 'scenes/Dashboard/scenes/CorporateManager/scenes/CorporateDetailsView/components/CorporateDataForm/components/CorporateFeaturesSelect.component'
import { FastField } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Typography } from '@mui/material'

import { UserGroupSelect } from '../../../../../UsersManager/scenes/UserDetailsView/components/UserDataForm/components'
import { useCorporateDataFormStyles } from '../../../../../UsersManager/scenes/UserDetailsView/components/UserDataForm/CorporateDataForm.styles'
import { CorporateStatusSelect } from './components'
import { CorporateAdminNotes } from './CorporateAdminNotes.component'

export type CorporateCommonDataProps = ExtendableStyles & Testable

export function CorporateCommonData({ ...styleProps }: CorporateCommonDataProps) {
  const { classes } = useCorporateDataFormStyles()

  const { values } = useFormikContext<CorporateWithSeats>()

  return (
    <>
      <FormSection title="Corporate information" {...styleProps}>
        <div className={classes.formContainer}>
          <FastField className={classes.field} component={TextField} label="Name" name="name" required />
        </div>
        <div className={classes.formContainer}>
          <FastField
            component={CorporateStatusSelect}
            className={classes.field}
            label="Corporate status"
            name="status"
            disableClearable
            required
          />
          <FastField
            component={CorporateFeaturesSelect}
            className={classes.field}
            label="Corporate premium features"
            name="enabledFeatures"
            required
          />
          <FastField
            type="checkbox"
            component={SwitchField}
            label="Demo?"
            name="demo"
            className={classes.inlineField}
          />
        </div>
        <div className={classes.formContainer}>
          <FastField
            className={classes.inlineField}
            component={TextField}
            type="number"
            min={0}
            label="Seats Limit"
            name="seatsLimit"
            required
          />
          <FastField className={classes.field} component={TextField} label="Logo URL" name="logoUrl" />
          <FastField className={classes.field} component={TextField} label="Website URL" name="websiteUrl" />
        </div>
        <Typography variant="caption" className={classes.label} style={{ display: 'flex' }}>
          {values.seatsUsed ? `Seats used: ${values?.seatsUsed}/${values.seatsLimit}` : 'Seats used: 0'}
        </Typography>
      </FormSection>

      <FormSection title="Usergroup information" subtitle="⚠️ Soon to be deprecated" {...styleProps}>
        <div className={classNames(classes.formContainer)}>
          <FastField
            component={NumberField}
            className={classes.field}
            label="UserGroup id"
            name="userGroupId"
            disabled
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
          <FastField
            component={UserGroupSelect}
            className={classes.field}
            label="UserGroup name"
            name="userGroup"
            fullWidth
          />
        </div>
      </FormSection>
      <CorporateAdminNotes />
    </>
  )
}
